export default __webpack_public_path__ + "static/media/fireworks.3d7669ad.png";